class DiscountCoupon extends HTMLElement {
  constructor() {
    super();
    this.originalText = this.querySelector('.discount-coupon__code').textContent;
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick.bind(this));
  }

  handleClick() {
    const codeElement = this.querySelector('.discount-coupon__code');
    const codeText = codeElement.textContent;

    // Copy the text to the clipboard
    navigator.clipboard.writeText(codeText).then(() => {
      // Change the text content to 'COPIED' after successfully copying
      codeElement.textContent = 'COPIED';
      setTimeout(() => {
        codeElement.textContent = this.originalText;
      }, 2000);
    }).catch(err => {
      console.error('Failed to copy text: ', err);
    });
  }
}

customElements.define('discount-coupon', DiscountCoupon);

class BuyNowButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleButtonClick.bind(this));
  }

  handleButtonClick(evt) {
    evt.preventDefault();

    // Get the button that was clicked
    const clickedButton = evt.target;
    console.log('clicked', clickedButton);

    if (!clickedButton) {
      return;
    }

    // Find the closest `.product-container` relative to the clicked button
    const container = clickedButton.closest('.product-single__meta');
    if (!container) {
      console.error('Product container not found!');
      return;
    }

    // Rest of the code remains unchanged
    const selectedSize = container.querySelector('input[name="Size"]:checked');
    const sizeSelectionErrorMessageElement = container.querySelector('.size-selection-error-msg');

    if (!selectedSize) {
      // Show the error message by adding the class
      sizeSelectionErrorMessageElement.classList.remove('hide-size-selection-error-msg');
      sizeSelectionErrorMessageElement.classList.add('show-size-selection-error-msg');

      const firstSizeInput = container.querySelector('input[name="Size"]');
      if (firstSizeInput) {
        const sizeClass = firstSizeInput.className;

        const sizeSection = container.querySelector(`.${sizeClass.split(' ').join('.')}`);
        if (sizeSection) {
          firstSizeInput.scrollIntoView({ block: "center", behavior: 'smooth' });
        } else {
          console.error('Size section not found!');
        }
      }
      return;
    } else {
      // Hide the error message by removing the class
      sizeSelectionErrorMessageElement.classList.remove('show-size-selection-error-msg');
      sizeSelectionErrorMessageElement.classList.add('hide-size-selection-error-msg');
    }
  }
}

// Define the custom element
customElements.define('buy-now-button', BuyNowButton);

class CustomAnnouncementSlides extends HTMLElement {
  constructor() {
    super();
    this.initSlider();
  }

  initSlider() {
    const sliderContainer = this.querySelector('.custom-announcement-bar');
    const sliders = this.querySelectorAll('.custom-announcement-bar__slide');

    if(sliders.length <= 1){
      return
    }
    
    let currentIndex = 0;

    // Get the dynamic transition time from the data attribute
    const transitionTime = parseInt(sliderContainer.dataset.transition) * 1000;
    const intervalTime = transitionTime;

    // Set transition duration dynamically in JavaScript
    sliders.forEach(slide => {
      slide.style.transition = `transform ${transitionTime}ms cubic-bezier(0.4, 0, 0.2, 1)`;
    });

    function showNextSlide() {
      let previousIndex = currentIndex;

      if (window.innerWidth <= 768) {
        // Slide from right to left for max width 768px
        sliders[currentIndex].style.zIndex = 0;
        sliders[currentIndex].style.opacity = 1;
        sliders[currentIndex].style.transform = 'translateX(-200%)';

        // Increment the index to show the next slide
        currentIndex = (currentIndex + 1) % sliders.length;

        sliders[currentIndex].style.zIndex = 1;
        sliders[currentIndex].style.opacity = 1;
        sliders[currentIndex].style.transform = 'translateX(0)';

        setTimeout(function () {
          sliders[previousIndex].style.opacity = 0;
          sliders[previousIndex].style.transform = 'translateX(200%)';
        }, transitionTime);
      } else {
        // Default vertical slide for larger screens
        sliders[currentIndex].style.zIndex = 0;
        sliders[currentIndex].style.opacity = 1;
        sliders[currentIndex].style.transform = 'translateY(-200%)';

        // Increment the index to show the next slide
        currentIndex = (currentIndex + 1) % sliders.length;

        sliders[currentIndex].style.zIndex = 1;
        sliders[currentIndex].style.opacity = 1;
        sliders[currentIndex].style.transform = 'translateY(0)';

        setTimeout(function () {
          sliders[previousIndex].style.opacity = 0;
          sliders[previousIndex].style.transform = 'translateY(200%)';
        }, transitionTime);
      }
    }

    // Start the slide show with dynamic interval time
    let slideInterval = setInterval(showNextSlide, intervalTime);

    // Pause the slider on hover
    this.addEventListener('mouseover', function() {
      clearInterval(slideInterval);
    });

    // Resume the slider when not hovering
    this.addEventListener('mouseout', function() {
      slideInterval = setInterval(showNextSlide, intervalTime);
    });

    // Mobile: touch events
    this.addEventListener('touchstart', pauseSlider);
    this.addEventListener('touchend', resumeSlider);
    this.addEventListener('touchcancel', resumeSlider);

    // Functions to pause and resume slider
    function pauseSlider() {
      clearInterval(slideInterval);
    }

    function resumeSlider() {
      slideInterval = setInterval(showNextSlide, intervalTime);
    }

    // Ensure responsiveness on resize
    window.addEventListener('resize', function() {
      clearInterval(slideInterval);
      slideInterval = setInterval(showNextSlide, intervalTime);
    });
  }
}

// Define the new custom element
customElements.define('custom-announcement-slides', CustomAnnouncementSlides);

class CustomAnnouncementMarquee extends HTMLElement {
  constructor() {
    super();
    this.scrollingElements = this.querySelectorAll('.custom-scrolling-text__inner');
  }

  connectedCallback() {
    // Add event listeners for hover and touch events
    this.addEventListener('mouseenter', this.pauseAnimation);
    this.addEventListener('mouseleave', this.playAnimation);
    this.addEventListener('touchstart', this.pauseAnimation);
    this.addEventListener('touchend', this.playAnimation);
  }

  pauseAnimation() {
    this.scrollingElements.forEach(element => {
      element.style.animationPlayState = 'paused';
    });
  }

  playAnimation() {
    this.scrollingElements.forEach(element => {
      element.style.animationPlayState = 'running';
    });
  }
}

// Register the custom element
customElements.define('custom-announcement-marquee', CustomAnnouncementMarquee);


$(document).ready(function(){
  setTimeout(function() {
    clevertap.privacy.push({useIP: true});
  }, 1000);
  console.log('Clevertap Push');

  $('body').on('click','span.share__icon',function(){
    $('.share__social_media').toggle();
  });
  $('body').on('click','.customProductSticky.sold__out_products',function(){
     var container = $('.template-product');
             var scrollTo = $('#zooomybackinstock');
             var position = scrollTo.offset().top
				- container.offset().top
				+ container.scrollTop()-200;
      $('body#news,html').animate({scrollTop:position}, 600);
  });
});

// To add the click events for read more , read less buttons in the SEO rich text section
$(document).ready(function() {
  if ($('.more_less').length > 0) { // Check if elements with class '.more_less' exist
      $('body').on('click', '.read_more_button', function() {
          $(this).closest('.more_less').find('.read_more').hide();
          $(this).closest('.more_less').find('.read_less').show();
      });
      $('body').on('click', '.read_less_button', function() {
          $(this).closest('.more_less').find('.read_less').hide();
          $(this).closest('.more_less').find('.read_more').show();
      });
  }
});


class SlickSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Get options from data-options attribute
    const options = this.dataset.sliderOptions ? JSON.parse(this.dataset.sliderOptions) : {};

    // Initialize Slick on the children of the custom element
    $(this).slick(options);
  }
}

// Define the custom element
customElements.define('slick-slider', SlickSlider);

// Cart Shipping
 document.addEventListener('DOMContentLoaded', function () {
  const INR_THRESHOLD = 10522.97; // ₹ threshold
  const BRAND_COLOR = '#52a09e';
  const IN_TO_USD_RATE = 1 / 87.69; // Conversion

  function formatUSD(amount) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  }

  function updateShippingBar() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const itemCount = cart.item_count;
        const subtotalLocal = cart.total_price / 100;

        let subtotalInINR = subtotalLocal;
        if (Shopify.currency && Shopify.currency.active !== 'INR' && Shopify.currency.rate) {
          subtotalInINR = subtotalLocal * Shopify.currency.rate;
        }

        const subtotalUSD = subtotalInINR * IN_TO_USD_RATE;
        const thresholdUSD = INR_THRESHOLD * IN_TO_USD_RATE;

        const bar = document.getElementById('free-shipping-bar');
        const textEl = document.getElementById('shipping-text');
        const progressEl = document.getElementById('shipping-progress');

        if (!bar || !textEl || !progressEl) return;

        if (itemCount === 0 || subtotalInINR < 1) {
          bar.style.display = 'none';
          return;
        }

        const remainingUSD = Math.max(0, thresholdUSD - subtotalUSD);
        const progress = Math.min(100, (subtotalUSD / thresholdUSD) * 100).toFixed(0);

        bar.style.display = 'block';

        if (subtotalUSD >= thresholdUSD) {
          textEl.innerHTML = '<strong>🎉 You’ve unlocked FREE shipping!</strong>';
        } else {
          textEl.innerHTML = `<strong>Hey! You’re just ${formatUSD(remainingUSD)} away from FREE shipping!</strong>`;
        }

        progressEl.style.width = `${progress}%`;
      });
  }

  // Function to check country with fallback
  function getUserCountry(callback) {
    fetch('https://ipapi.co/json/')
      .then(res => res.json())
      .then(data => {
        if (data && data.country_name) {
          callback(data.country_name);
        } else {
          throw new Error('Primary location API failed');
        }
      })
      .catch(() => {
        // Fallback to another API
        fetch('https://ipwho.is/')
          .then(res => res.json())
          .then(data => callback(data.country || 'Unknown'))
          .catch(() => callback('Unknown'));
      });
  }

  // Run only for non-India users
  getUserCountry(country => {
    if (country !== 'India') {
      updateShippingBar();

      document.addEventListener('cart:updated', updateShippingBar);
      document.addEventListener('cart:refresh', updateShippingBar);

      const drawer = document.querySelector('.cart-drawer, #CartDrawer');
      if (drawer) {
        const observer = new MutationObserver(updateShippingBar);
        observer.observe(drawer, { childList: true, subtree: true });
      }
    }
  });
});

